import { render, staticRenderFns } from "./reportIMSSalestable.vue?vue&type=template&id=4d7a51dc&scoped=true&"
import script from "./reportIMSSalestable.vue?vue&type=script&lang=js&"
export * from "./reportIMSSalestable.vue?vue&type=script&lang=js&"
import style0 from "./reportIMSSalestable.vue?vue&type=style&index=0&id=4d7a51dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a51dc",
  null
  
)

export default component.exports